import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-7 flex flex-col justify-start items-stretch h-full w-full overflow-y-auto max-w-14xl" }
const _hoisted_2 = { class: "flex justify-center items-center h-6 mt-2 mb-4 mx-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 text-xl" }, "修改个人信息", -1)
const _hoisted_4 = { class: "w-full max-w-sm self-center flex items-end mb-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 修改头像 ")
const _hoisted_7 = { class: "w-full max-w-sm self-center mb-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 保存修改 ")
const _hoisted_9 = { class: "w-full max-w-sm self-center mb-4" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 发送验证码 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 更换邮箱（开发中） ")
const _hoisted_13 = { class: "w-full max-w-sm self-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 修改密码 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_button = _resolveComponent("f-button")!
  const _component_f_input = _resolveComponent("f-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "absolute left-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/user')))
      }, [
        _createVNode(_component_f_icon, {
          name: "back",
          width: 14,
          height: 24
        })
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "bg-gray-100 w-16 h-16 rounded-full mr-5",
        src: _ctx.processAvatar(_ctx.user.avatar),
        alt: "avatar"
      }, null, 8, _hoisted_5),
      _createElementVNode("input", {
        id: "upload",
        style: {"display":"none"},
        accept: "image/png, image/jpeg, image/jpg, image/bmp",
        type: "file",
        onChange: _cache[1] || (_cache[1] = 
          (e) =>
            _ctx.handleAvatarUploaded(
              (e.target.files && e.target.files.length && e.target.files[0]) || null,
            )
        )
      }, null, 32),
      _createVNode(_component_f_button, {
        class: "flex-1",
        type: "primary",
        shape: "circle",
        disabled: _ctx.isAvatarUploading,
        loading: _ctx.isAvatarUploading,
        onClick: _ctx.handleClickModifyAvatar
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createVNode(_component_f_input, {
          modelValue: _ctx.nickname,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nickname) = $event)),
          rules: [(v) => v.length <= 10 || '昵称最长 10 个字哦'],
          counter: 10,
          dense: "",
          label: "昵称",
          outlined: ""
        }, null, 8, ["modelValue", "rules"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_f_input, {
          modelValue: _ctx.bio,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bio) = $event)),
          rules: [(v) => v.length <= 50 || '个性签名最长 50 个字哦'],
          counter: 50,
          dense: "",
          label: "个性签名",
          outlined: ""
        }, null, 8, ["modelValue", "rules"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_f_button, {
          class: "w-full",
          type: "primary",
          shape: "circle",
          disabled: !_ctx.isInfoModified || _ctx.isInfoModifying,
          loading: _ctx.isInfoModifying,
          onClick: _ctx.handleClickModifyInfo
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        _createVNode(_component_f_input, {
          dense: "",
          label: "邮箱",
          clearable: "",
          outlined: "",
          disabled: "",
          suffix: "@fudan.edu.cn"
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_f_input, {
          dense: "",
          label: "验证码",
          outlined: "",
          disabled: ""
        }),
        _createVNode(_component_f_button, {
          class: "mt-0.5 w-24 ml-3",
          type: "primary",
          shape: "circle",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_f_button, {
          class: "w-full",
          type: "primary",
          shape: "circle",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", null, [
        _createVNode(_component_f_input, {
          modelValue: _ctx.oldPassword,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.oldPassword) = $event)),
          type: "password",
          label: "旧密码",
          dense: "",
          clearable: "",
          outlined: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_f_input, {
          modelValue: _ctx.newPassword,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPassword) = $event)),
          type: "password",
          label: "新密码",
          dense: "",
          clearable: "",
          outlined: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_f_input, {
          modelValue: _ctx.confirmPassword,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmPassword) = $event)),
          type: "password",
          label: "确认新密码",
          dense: "",
          clearable: "",
          outlined: ""
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_f_button, {
        class: "w-full",
        type: "primary",
        shape: "circle",
        onClick: _ctx.handleClickChangePassword
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}